import React, { useMemo } from 'react'
import { Grid } from '@material-ui/core'
import { useGetAiUsage } from '../../../../../api/denaliAssistant'
import Loading from '../../../../../components/molecules/Loading'
import ChartProvider from '../../../../../components/charts/echarts/ChartProvider'
import ComponentBar from '../../../../../components/charts/echarts/ComponentBar'
import AxisX from '../../../../../components/charts/echarts/AxisX'
import AxisY from '../../../../../components/charts/echarts/AxisY'
import ChartTooltip from '../../../../../components/molecules/ChartTooltip'

function UsageBarChart () {
  const { data, isLoading } = useGetAiUsage()

  const chartData = useMemo(() => {
    return data?.data.map(item => [item.date, item.invocations])
  }, [data])

  if (isLoading) {
    return <Loading />
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={{ height: 300, width: '100%' }}>
        <ChartProvider
          height={400}
          grid={{
            left: 10,
            right: 10,
            top: 20,
            bottom: 30,
            containLabel: true
          }}
          color={['#514E91', '#2EF0DD', '#0091F9', '#514E91', '#F6B143', '#A3DD40']}
          loadingTemplate='axis'
          legend={{
            show: true,
            right: 0,
            bottom: 0,
            orient: 'horizontal',
            padding: [5, 10],
            itemGap: 10
          }}
        >
          <ChartTooltip trigger='axis' valueFormat='0,0.0A' />
          <AxisX
            type='time'
            boundaryGap={false}
            axisLabel={{
              rotate: 45,
              interval: 1
            }}
            splitNumber={12}
            format='@MM/DD/YY'
          />
          <AxisY type='value' format='0' />
          <ComponentBar seriesId='invocations' name='AI Invocations' data={chartData} />
        </ChartProvider>
      </Grid>
    </Grid>
  )
}

UsageBarChart.propTypes = {}

export default UsageBarChart
